

























import { Component, Vue } from "vue-property-decorator";

@Component({
  props: {
    label: String,
    type: String,
    element: String,
    showPasswordAction: Boolean,
    value: [String, Number, Object, Boolean],
    input: Function,
    isInvalid: Boolean
  }
})
export default class InputComponent extends Vue {
  public focus: boolean = false;
  public showPassword: boolean = false;
}
